import { Directive, input } from '@angular/core';

@Directive({
  selector: '[mlSkeletonFade]',
  host: {
    class: 'ml-skeleton-fade',
    '[class.is-fading]': 'mlSkeletonFade()',
  },
})
export class SkeletonFadeDirective {
  readonly mlSkeletonFade = input(false);
}
